module.exports = __webpack_public_path__ + "img/brake.45ec1261.jpg";